import { addNamespace } from '@/app/shared/utils/NamespaceHelper'
import longGrid, { Types as TypesLongGrid } from '@/app/shared/store/modules/LongGrid'

const NAMESPACE = 'weeklySales/weeklyDetail/'

const metricsNormalCurrentYear = [
  'quantity_sold_2',
  'quantity_sold_1',
  'real_sales_amount_2',
  'real_sales_amount_1',
  'real_sales_cost_2',
  'real_sales_cost_1'
]

const buildWeeklyDetailDefaultParameters = (weekNumber) => {
  return {
    calculatedField: [
      'COALESCE((SUM(real_sales_amount_1) - SUM(real_sales_cost_1)) / NULLIF(SUM(real_sales_amount_1),0), 0) as mg_1',
      'COALESCE((SUM(real_sales_amount_2) - SUM(real_sales_cost_2)) / NULLIF(SUM(real_sales_amount_2),0), 0) as mg_2'
    ],
    factTableName: 'dw_weekly_sales_comparative',
    metrics: {
      normal: metricsNormalCurrentYear,
      var: [
        'quantity_sold',
        'real_sales_amount',
        'real_sales_cost'
      ]
    },
    dateFilters: {
      calendarweekstr: {
        operator: 'BT',
        value: [weekNumber, weekNumber]
      }
    }
  }
}

const _types = {
  getters: {
    BASE_DIMENSION: 'BASE_DIMENSION',
    PIVOT_DIMENSIONS: 'PIVOT_DIMENSIONS',
    PIVOTED_FILTER_DIMENSION_IDS: 'PIVOTED_FILTER_DIMENSION_IDS'
  },
  actions: {
    INIT: 'INIT',
    APPLY_FILTERS: 'APPLY_FILTERS',
    CHANGE_BASE_DIMENSION: 'CHANGE_BASE_DIMENSION',
    CHANGE_PIVOT: 'CHANGE_PIVOT',
    POP_UNTIL_BREADCRUMB: 'POP_UNTIL_BREADCRUMB',
    DOWNLOAD_GRID_TO_EXCEL: 'DOWNLOAD_GRID_TO_EXCEL',
    RESET: 'RESET'
  }
}

export const Types = addNamespace(NAMESPACE, _types)

const WeeklyDetail = {
  namespaced: true,
  state: {
  },
  getters: {
    [_types.getters.BASE_DIMENSION]: (state, getters) => {
      return getters[TypesLongGrid.getters.BASE_DIMENSION]
    },
    [_types.getters.PIVOT_DIMENSIONS]: (state, getters) => {
      return getters[TypesLongGrid.getters.PIVOT_DIMENSIONS]
    },
    [_types.getters.PIVOTED_FILTER_DIMENSION_IDS]: (state, getters) => {
      return getters[TypesLongGrid.getters.PIVOTED_FILTER_DIMENSION_IDS]
    }
  },
  actions: {
    [_types.actions.INIT] ({ dispatch, rootState }, { week, year }) {
      const { dimensions, filters } = rootState.weeklySales
      const defaultDimension = dimensions[0]
      const weekDetailDefaultParameters = buildWeeklyDetailDefaultParameters(week, year)
      dispatch(TypesLongGrid.actions.INIT, { dimensions, defaultDimension, defaultParameters: weekDetailDefaultParameters, filters })
    },
    [_types.actions.APPLY_FILTERS] ({ dispatch }, { storeFilters, productFilters }) {
      dispatch(TypesLongGrid.actions.APPLY_FILTERS, { storeFilters, productFilters })
    },
    [_types.actions.CHANGE_BASE_DIMENSION] ({ dispatch }, dimensionId) {
      dispatch(TypesLongGrid.actions.CHANGE_BASE_DIMENSION, dimensionId)
    },
    [_types.actions.CHANGE_PIVOT] ({ dispatch, rootState }, { params, option }) {
      dispatch(TypesLongGrid.actions.CHANGE_PIVOT, { params, option })
    },
    [_types.actions.POP_UNTIL_BREADCRUMB] ({ dispatch }, breadCrumbItem) {
      dispatch(TypesLongGrid.actions.POP_UNTIL_BREADCRUMB, breadCrumbItem)
    },
    [_types.actions.DOWNLOAD_GRID_TO_EXCEL] ({ dispatch }) {
      dispatch(TypesLongGrid.actions.DOWNLOAD_GRID_TO_EXCEL)
    },
    [_types.actions.RESET] ({ dispatch }) {
      dispatch(TypesLongGrid.actions.RESET)
    }
  },
  modules: {
    longGrid
  }
}

export default WeeklyDetail



// WEBPACK FOOTER //
// ./src/app/weekly_sales/store/WeeklyDetail.js